export const CafeBazaarDownloadUrl = 'https://click.adtrace.io/x938m8i'
export const MykeyDownloadUrl = 'https://click.adtrace.io/4qyov8f'
